module.exports = __webpack_public_path__ + "img/logo.6ae13d2f.png";